// Reads a ?openInstallment=1 query param alongside the existing #event-<id> anchor
// already used for deep-linking to a specific event card, and — once the Contact
// modal system is ready — programmatically clicks that event's real Installment
// button (data-modal-type="installment", rendered in views/pages/events/
// simple-event-page.ejs only when locData.priceInstall is set). Reuses the exact
// same click-delegation path a real user click takes (GlobalContactListener /
// ClickHandler, see src/scripts/contact/handlers/) rather than duplicating any
// modal-opening logic here — if that system's internals ever change, this keeps
// working as long as clicking the real button still opens the real modal.
import { domReady } from '../utils/dom.js';

const READY_POLL_MS = 100;
const READY_TIMEOUT_MS = 4000;

// window.ContactSystem is set at the very end of initializeContactSystem()
// (src/scripts/contact/internal/init.js) — its presence is the public signal that
// GlobalContactListener's delegated click handler is actually attached, which a
// synthesized .click() below depends on to do anything at all.
function waitForContactSystem() {
    if (window.ContactSystem) return Promise.resolve(true);
    return new Promise(resolve => {
        const start = Date.now();
        const poll = setInterval(() => {
            if (window.ContactSystem) {
                clearInterval(poll);
                resolve(true);
            } else if (Date.now() - start > READY_TIMEOUT_MS) {
                clearInterval(poll);
                resolve(false);
            }
        }, READY_POLL_MS);
    });
}

export function initInstallmentAutoOpen() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('openInstallment') !== '1') return;

    const anchorId = window.location.hash.replace(/^#/, '');
    if (!anchorId) return;

    domReady(async () => {
        const ready = await waitForContactSystem();
        if (!ready) return;
        // The anchor (config.anchor, from base-events.json) lands on the group's
        // <h3 class="group-title">, not on an individual occurrence's <article
        // class="simple-event-card" id="event-...">, which has its own separate,
        // Google-Calendar-ID-derived id — the two are siblings under the same
        // .simple-event-group, not nested. So the button is found by scoping up to
        // that shared group container, then down to its first installment button,
        // rather than treating the anchor id as if it belonged to the card itself.
        const anchorEl = document.getElementById(anchorId);
        const group = anchorEl?.closest('.simple-event-group');
        const button = group?.querySelector('[data-modal-type="installment"]');
        button?.click();
    });
}
